import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.pug = bracketIndenting({
	line: "//-",
})
